import { render } from "./ParenthesisPost.vue?vue&type=template&id=2816e3c6&scoped=true"
import script from "./ParenthesisPost.vue?vue&type=script&lang=js"
export * from "./ParenthesisPost.vue?vue&type=script&lang=js"

import "./ParenthesisPost.vue?vue&type=style&index=0&id=2816e3c6&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2816e3c6"]])

export default __exports__